<div class="card-header text-uppercase">Uploads</div>
<div>
  <app-dados-fundo
    #wallet
    [isWallet]="true"
    [canEdit]="true"
    [isWalletUpload]="true"
    (emitterSelectedFundStock)="getStockSelectedFund($event)"
  >
  </app-dados-fundo>
  <br />
  <div
    *ngIf="
      allStock?.stockFund?.positions?.length > 0 ||
      allStock?.stockFund?.marketPositions?.length > 0
    "
  >
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        Estoque de Fundos.
        <span *ngIf="fundPositionDate != null"
          >Data da Posição:
          {{ fundPositionDate | date : "dd/MM/yyyy" : "GMT" }}</span
        >
      </mat-expansion-panel-header>
      <mat-expansion-panel [expanded]=""> </mat-expansion-panel>
      <div class="d-block p-2 bg-dark text-white text-center">
        À vista. {{ fundPositionCount }}
      </div>
      <div class="card-body">
        <div class="row mb-2">
          <div class="col-12">
            <h6 *ngIf="allStock?.stockFund?.positions == null">
              Selecione um fundo para buscar os dados do estoque.
            </h6>
            <h6 *ngIf="allStock?.stockFund?.positions?.length == 0">
              Não foram encontrados dados de estoque para esta carteira.
            </h6>
            <div
              class="table-container"
              *ngIf="allStock?.stockFund?.positions?.length > 0"
            >
              <div class="table-container">
                <table
                  mat-table
                  [dataSource]="allStock.stockFund.positions"
                  class="col-12"
                >
                  <ng-container matColumnDef="fundSourceId">
                    <th mat-header-cell *matHeaderCellDef>Cód. do Fundo</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.fundSourceId }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="fundName">
                    <th mat-header-cell *matHeaderCellDef>Nome do Fundo</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.fundName }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="institutionName">
                    <th mat-header-cell *matHeaderCellDef>
                      Nome da Instituição
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.institutionName }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="availableQuantity">
                    <th mat-header-cell *matHeaderCellDef>
                      Quantidade Disponível
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.availableQuantity }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="quotaValue">
                    <th mat-header-cell *matHeaderCellDef>Valor da Cota</th>
                    <td mat-cell *matCellDef="let element">
                      {{
                        element.quotaValue
                          | currency : "R$" : "symbol" : "1.8-8"
                      }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="netValue">
                    <th mat-header-cell *matHeaderCellDef>Valor Líquido</th>
                    <td mat-cell *matCellDef="let element">
                      {{
                        element.netValue | currency : "R$" : "symbol" : "1.2-2"
                      }}
                    </td>
                  </ng-container>

                  <tr
                    mat-header-row
                    *matHeaderRowDef="columnsFund; sticky: true"
                  ></tr>
                  <tr mat-row *matRowDef="let row; columns: columnsFund"></tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-block p-2 bg-dark text-white text-center">
        Mercado. {{ fundMarketPositionCount }}
      </div>
      <div class="card-body">
        <div class="row mb-2">
          <div class="col-12">
            <h6 *ngIf="allStock?.stockFund?.marketPositions == null">
              Selecione um fundo para buscar os dados do estoque.
            </h6>
            <h6 *ngIf="allStock?.stockFund?.marketPositions?.length == 0">
              Não foram encontrados dados de estoque para esta carteira.
            </h6>
            <div
              class="table-container"
              *ngIf="allStock?.stockFund?.marketPositions?.length > 0"
            >
              <div class="table-container">
                <table
                  mat-table
                  [dataSource]="allStock.stockFund.marketPositions"
                  class="col-12"
                >
                  <ng-container matColumnDef="fundSourceId">
                    <th mat-header-cell *matHeaderCellDef>Cód. do Fundo</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.fundSourceId }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="institutionName">
                    <th mat-header-cell *matHeaderCellDef>Instituição</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.institutionName }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="availableQuantity">
                    <th mat-header-cell *matHeaderCellDef>
                      Quantidade Disponível
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.availableQuantity }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="result">
                    <th mat-header-cell *matHeaderCellDef>Resultado</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.result }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="totalCost">
                    <th mat-header-cell *matHeaderCellDef>Custo Total</th>
                    <td mat-cell *matCellDef="let element">
                      {{
                        element.totalCost | currency : "R$" : "symbol" : "1.8-8"
                      }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="netValue">
                    <th mat-header-cell *matHeaderCellDef>Valor Líquido</th>
                    <td mat-cell *matCellDef="let element">
                      {{
                        element.netValue | currency : "R$" : "symbol" : "1.2-2"
                      }}
                    </td>
                  </ng-container>

                  <tr
                    mat-header-row
                    *matHeaderRowDef="columnsFundMarket; sticky: true"
                  ></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; columns: columnsFundMarket"
                  ></tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-expansion-panel>
    <br />
  </div>
  <div
    *ngIf="
      allStock?.stockFixedIncome?.positions?.length > 0 ||
      allStock?.stockFixedIncome?.committedPositions?.length > 0 ||
      allStock?.stockFixedIncome?.termPositions?.length > 0
    "
  >
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        Estoque de Renda Fixa.
        <span *ngIf="fixedPositionDate != null"
          >Data da Posição:
          {{ fixedPositionDate | date : "dd/MM/yyyy" : "GMT" }}</span
        >
      </mat-expansion-panel-header>
      <div class="d-block p-2 bg-dark text-white text-center">
        À vista. {{ fixedPositionCount }}
      </div>
      <div class="card-body">
        <div class="row mb-2">
          <div class="col-12">
            <h6 *ngIf="allStock?.stockFixedIncome?.positions == null">
              Selecione um fundo para buscar os dados do estoque.
            </h6>
            <h6 *ngIf="allStock?.stockFixedIncome?.positions?.length == 0">
              Não foram encontrados dados de estoque para esta carteira.
            </h6>
            <div
              class="table-container"
              *ngIf="allStock?.stockFixedIncome?.positions?.length > 0"
            >
              <div class="table-container">
                <table
                  mat-table
                  [dataSource]="allStock.stockFixedIncome.positions"
                  class="col-12"
                >
                  <ng-container matColumnDef="code">
                    <th mat-header-cell *matHeaderCellDef>Cód. RF</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.code }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="selicCode">
                    <th mat-header-cell *matHeaderCellDef>Cód. Selic</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.selicCode }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="operationCode">
                    <th mat-header-cell *matHeaderCellDef>Cód. da Operação</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.operationCode }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="purchaseDate">
                    <th mat-header-cell *matHeaderCellDef>Data da Compra</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.purchaseDate | date : "dd/MM/yyyy" : "GMT" }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="issueCode">
                    <th mat-header-cell *matHeaderCellDef>Emissão</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.issueCode }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="issuerName">
                    <th mat-header-cell *matHeaderCellDef>Emissor</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.issuerName }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="serie">
                    <th mat-header-cell *matHeaderCellDef>Série</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.serie }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="issueDate">
                    <th mat-header-cell *matHeaderCellDef>Data de Emissão</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.issueDate | date : "dd/MM/yyyy" : "GMT" }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="dueDate">
                    <th mat-header-cell *matHeaderCellDef>
                      Data de Vencimento
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.dueDate | date : "dd/MM/yyyy" : "GMT" }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="quantity">
                    <th mat-header-cell *matHeaderCellDef>Quantidade</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.quantity }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="pu">
                    <th mat-header-cell *matHeaderCellDef>PU</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.pu | currency : "R$" : "symbol" : "1.8-8" }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="purchaseValue">
                    <th mat-header-cell *matHeaderCellDef>Valor de Compra</th>
                    <td mat-cell *matCellDef="let element">
                      {{
                        element.purchaseValue
                          | currency : "R$" : "symbol" : "1.2-2"
                      }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="netValue">
                    <th mat-header-cell *matHeaderCellDef>Valor Líquido</th>
                    <td mat-cell *matCellDef="let element">
                      {{
                        element.netValue | currency : "R$" : "symbol" : "1.2-2"
                      }}
                    </td>
                  </ng-container>

                  <tr
                    mat-header-row
                    *matHeaderRowDef="columnsFixedIncome; sticky: true"
                  ></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; columns: columnsFixedIncome"
                  ></tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-block p-2 bg-dark text-white text-center">
        Compromissada. {{ fixedCommittedPositionCount }}
      </div>
      <div class="card-body">
        <div class="row mb-2">
          <div class="col-12">
            <h6 *ngIf="allStock?.stockFixedIncome?.committedPositions == null">
              Selecione um fundo para buscar os dados do estoque.
            </h6>
            <h6
              *ngIf="
                allStock?.stockFixedIncome?.committedPositions?.length == 0
              "
            >
              Não foram encontrados dados de estoque para esta carteira.
            </h6>
            <div
              class="table-container"
              *ngIf="allStock?.stockFixedIncome?.committedPositions?.length > 0"
            >
              <div class="table-container">
                <table
                  mat-table
                  [dataSource]="allStock.stockFixedIncome.committedPositions"
                  class="col-12"
                >
                  <ng-container matColumnDef="operationCode">
                    <th mat-header-cell *matHeaderCellDef>Cód. de Operação</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.operationCode }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="purchaseDate">
                    <th mat-header-cell *matHeaderCellDef>Data da Compra</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.purchaseDate | date : "dd/MM/yyyy" : "GMT" }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="securityName">
                    <th mat-header-cell *matHeaderCellDef>Nome Segurança</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.securityName }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="originalDate">
                    <th mat-header-cell *matHeaderCellDef>Data Original</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.originalDate | date : "dd/MM/yyyy" : "GMT" }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="dueDate">
                    <th mat-header-cell *matHeaderCellDef>
                      Data de Vencimento
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.dueDate | date : "dd/MM/yyyy" : "GMT" }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="issuerName">
                    <th mat-header-cell *matHeaderCellDef>Nome do Emissor</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.issuerName }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="quantity">
                    <th mat-header-cell *matHeaderCellDef>Quantidade</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.quantity }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="pu">
                    <th mat-header-cell *matHeaderCellDef>PU</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.pu | currency : "R$" : "symbol" : "1.8-8" }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="purchaseValue">
                    <th mat-header-cell *matHeaderCellDef>Valor de Compra</th>
                    <td mat-cell *matCellDef="let element">
                      {{
                        element.purchaseValue
                          | currency : "R$" : "symbol" : "1.2-2"
                      }}
                    </td>
                  </ng-container>

                  <tr
                    mat-header-row
                    *matHeaderRowDef="columnsFixedIncomeCommitted; sticky: true"
                  ></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; columns: columnsFixedIncomeCommitted"
                  ></tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-block p-2 bg-dark text-white text-center">
        Termo. {{ fixedTermPositionCount }}
      </div>
      <div class="card-body">
        <div class="row mb-2">
          <div class="col-12">
            <h6 *ngIf="allStock?.stockFixedIncome?.termPositions == null">
              Selecione um fundo para buscar os dados do estoque.
            </h6>
            <h6 *ngIf="allStock?.stockFixedIncome?.termPositions?.length == 0">
              Não foram encontrados dados de estoque para esta carteira.
            </h6>
            <div
              class="table-container"
              *ngIf="allStock?.stockFixedIncome?.termPositions?.length > 0"
            >
              <div class="table-container">
                <table
                  mat-table
                  [dataSource]="allStock.stockFixedIncome.termPositions"
                  class="col-12"
                >
                  <ng-container matColumnDef="operationCode">
                    <th mat-header-cell *matHeaderCellDef>Cód. de Operação</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.operationCode }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="purchaseDate">
                    <th mat-header-cell *matHeaderCellDef>Data da Compra</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.purchaseDate | date : "dd/MM/yyyy" : "GMT" }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="issuerName">
                    <th mat-header-cell *matHeaderCellDef>Nome do Emissor</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.issuerName }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="securityName">
                    <th mat-header-cell *matHeaderCellDef>Nome Segurança</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.securityName }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="series">
                    <th mat-header-cell *matHeaderCellDef>Série</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.series }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="issueDate">
                    <th mat-header-cell *matHeaderCellDef>Data de Emissão</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.issueDate | date : "dd/MM/yyyy" : "GMT" }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="dueDate">
                    <th mat-header-cell *matHeaderCellDef>
                      Data de Vencimento
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.dueDate | date : "dd/MM/yyyy" : "GMT" }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="quantity">
                    <th mat-header-cell *matHeaderCellDef>Quantidade</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.quantity }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="pu">
                    <th mat-header-cell *matHeaderCellDef>PU</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.pu | currency : "R$" : "symbol" : "1.8-8" }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="purchaseValue">
                    <th mat-header-cell *matHeaderCellDef>Valor de Compra</th>
                    <td mat-cell *matCellDef="let element">
                      {{
                        element.purchaseValue
                          | currency : "R$" : "symbol" : "1.2-2"
                      }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="netValue">
                    <th mat-header-cell *matHeaderCellDef>Valor Líquido</th>
                    <td mat-cell *matCellDef="let element">
                      {{
                        element.netValue | currency : "R$" : "symbol" : "1.2-2"
                      }}
                    </td>
                  </ng-container>

                  <tr
                    mat-header-row
                    *matHeaderRowDef="columnsFixedIncomeTerm; sticky: true"
                  ></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; columns: columnsFixedIncomeTerm"
                  ></tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-expansion-panel>
    <br />
  </div>

  <div
    *ngIf="
      allStock?.stockVariableIncome?.positions?.length > 0 ||
      allStock?.stockVariableIncome?.optionsPositions?.length > 0 ||
      allStock?.stockVariableIncome?.termPositions?.length > 0 ||
      allStock?.stockVariableIncome?.loanPositions?.length > 0
    "
  >
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        Estoque de Renda Variável.
        <span *ngIf="variablePositionDate != null"
          >Data da Posição:
          {{ variablePositionDate | date : "dd/MM/yyyy" : "GMT" }}</span
        >
      </mat-expansion-panel-header>
      <div class="d-block p-2 bg-dark text-white text-center">
        À Vista. {{ variablePositionCount }}
      </div>
      <div class="card-body">
        <div class="row mb-2">
          <div class="col-12">
            <h6 *ngIf="allStock?.stockVariableIncome?.positions == null">
              Selecione um fundo para buscar os dados do estoque.
            </h6>
            <h6 *ngIf="allStock?.stockVariableIncome?.positions?.length == 0">
              Não foram encontrados dados de estoque para esta carteira.
            </h6>
            <div
              class="table-container"
              *ngIf="allStock?.stockVariableIncome?.positions?.length > 0"
            >
              <div class="table-container">
                <table
                  mat-table
                  [dataSource]="allStock.stockVariableIncome.positions"
                  class="col-12"
                >
                  <ng-container matColumnDef="assetCode">
                    <th mat-header-cell *matHeaderCellDef>Cód. Ativo</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.assetCode }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="assetName">
                    <th mat-header-cell *matHeaderCellDef>Nome Ativo</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.assetName }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="availableAmount">
                    <th mat-header-cell *matHeaderCellDef>Qtd. Disponível</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.availableAmount }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="blockedAmount">
                    <th mat-header-cell *matHeaderCellDef>Qtd. Bloqueada</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.blockedAmount }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="totalAmount">
                    <th mat-header-cell *matHeaderCellDef>Qtd. Total</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.totalAmount }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="price">
                    <th mat-header-cell *matHeaderCellDef>Cotação</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.price | currency : "R$" : "symbol" : "1.8-8" }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="totalCost">
                    <th mat-header-cell *matHeaderCellDef>Custo Total</th>
                    <td mat-cell *matCellDef="let element">
                      {{
                        element.totalCost | currency : "R$" : "symbol" : "1.2-2"
                      }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="result">
                    <th mat-header-cell *matHeaderCellDef>Resultado</th>
                    <td mat-cell *matCellDef="let element">
                      {{
                        element.result | currency : "R$" : "symbol" : "1.2-2"
                      }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="netValue">
                    <th mat-header-cell *matHeaderCellDef>Valor Líquido</th>
                    <td mat-cell *matCellDef="let element">
                      {{
                        element.netValue | currency : "R$" : "symbol" : "1.2-2"
                      }}
                    </td>
                  </ng-container>
                  <tr
                    mat-header-row
                    *matHeaderRowDef="columnsVariableIncome; sticky: true"
                  ></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; columns: columnsVariableIncome"
                  ></tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-block p-2 bg-dark text-white text-center">
        Opções. {{ variableOptionsPositionCount }}
      </div>
      <div class="card-body">
        <div class="row mb-2">
          <div class="col-12">
            <h6 *ngIf="allStock?.stockVariableIncome?.optionsPositions == null">
              Selecione um fundo para buscar os dados do estoque.
            </h6>
            <h6
              *ngIf="
                allStock?.stockVariableIncome?.optionsPositions?.length == 0
              "
            >
              Não foram encontrados dados de estoque para esta carteira.
            </h6>
            <div
              class="table-container"
              *ngIf="
                allStock?.stockVariableIncome?.optionsPositions?.length > 0
              "
            >
              <div class="table-container">
                <table
                  mat-table
                  [dataSource]="allStock.stockVariableIncome.optionsPositions"
                  class="col-12"
                >
                  <ng-container matColumnDef="assetCode">
                    <th mat-header-cell *matHeaderCellDef>Cód. Ativo</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.assetCode }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="stockObject">
                    <th mat-header-cell *matHeaderCellDef>Estoque</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.stockObject }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="type">
                    <th mat-header-cell *matHeaderCellDef>Tipo</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.type }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="broker">
                    <th mat-header-cell *matHeaderCellDef>Corretora</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.broker }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="exerciseValue">
                    <th mat-header-cell *matHeaderCellDef>
                      Valor de Exercício
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.exerciseValue }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="dueDate">
                    <th mat-header-cell *matHeaderCellDef>
                      Data de Vencimento
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.dueDate | date : "dd/MM/yyyy" : "GMT" }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="totalAmount">
                    <th mat-header-cell *matHeaderCellDef>Quantidade total</th>
                    <td mat-cell *matCellDef="let element">
                      {{
                        element.totalAmount
                          | currency : "R$" : "symbol" : "1.8-8"
                      }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="price">
                    <th mat-header-cell *matHeaderCellDef>Preço</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.price | currency : "R$" : "symbol" : "1.2-2" }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="totalCost">
                    <th mat-header-cell *matHeaderCellDef>Valor Custo Total</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.totalCost }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="result">
                    <th mat-header-cell *matHeaderCellDef>Resultado</th>
                    <td mat-cell *matCellDef="let element">
                      {{
                        element.result | currency : "R$" : "symbol" : "1.2-2"
                      }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="netValue">
                    <th mat-header-cell *matHeaderCellDef>Valor Líquido</th>
                    <td mat-cell *matCellDef="let element">
                      {{
                        element.netValue | currency : "R$" : "symbol" : "1.2-2"
                      }}
                    </td>
                  </ng-container>
                  <tr
                    mat-header-row
                    *matHeaderRowDef="
                      columnsVariableIncomeOptions;
                      sticky: true
                    "
                  ></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; columns: columnsVariableIncomeOptions"
                  ></tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-block p-2 bg-dark text-white text-center">
        Termo. {{ variabletermPositionCount }}
      </div>
      <div class="card-body">
        <div class="row mb-2">
          <div class="col-12">
            <h6 *ngIf="allStock?.stockVariableIncome?.termPositions == null">
              Selecione um fundo para buscar os dados do estoque.
            </h6>
            <h6
              *ngIf="allStock?.stockVariableIncome?.termPositions?.length == 0"
            >
              Não foram encontrados dados de estoque para esta carteira.
            </h6>
            <div
              class="table-container"
              *ngIf="allStock?.stockVariableIncome?.termPositions?.length > 0"
            >
              <div class="table-container">
                <table
                  mat-table
                  [dataSource]="allStock.stockVariableIncome.termPositions"
                  class="col-12"
                >
                  <ng-container matColumnDef="operationCode">
                    <th mat-header-cell *matHeaderCellDef>Cód. de Operação</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.operationCode }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="stockObject">
                    <th mat-header-cell *matHeaderCellDef>Estoque</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.stockObject }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="type">
                    <th mat-header-cell *matHeaderCellDef>Tipo</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.type }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="amount">
                    <th mat-header-cell *matHeaderCellDef>Quantidade</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.amount }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="broker">
                    <th mat-header-cell *matHeaderCellDef>Corretora</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.broker }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="actualTermPrice">
                    <th mat-header-cell *matHeaderCellDef>Valor Termo Atual</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.actualTermPrice }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="originalContractValue">
                    <th mat-header-cell *matHeaderCellDef>
                      Valor Original do Contrato
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.originalContractValue }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="activeCashValue">
                    <th mat-header-cell *matHeaderCellDef>Valor Ativo</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.activeCashValue }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="passiveCashValue">
                    <th mat-header-cell *matHeaderCellDef>Valor Passivo</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.passiveCashValue }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="dueDate">
                    <th mat-header-cell *matHeaderCellDef>
                      Data de Vencimento
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.dueDate | date : "dd/MM/yyyy" : "GMT" }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="businessDaysDeadline">
                    <th mat-header-cell *matHeaderCellDef>Prazo em DU</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.businessDaysDeadline }}
                    </td>
                  </ng-container>
                  <tr
                    mat-header-row
                    *matHeaderRowDef="columnsVariableIncomeTerm; sticky: true"
                  ></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; columns: columnsVariableIncomeTerm"
                  ></tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-block p-2 bg-dark text-white text-center">
        Empréstimo. {{ variableloanPositionCount }}
      </div>
      <div class="card-body">
        <div class="row mb-2">
          <div class="col-12">
            <h6 *ngIf="allStock?.stockVariableIncome?.loanPositions == null">
              Selecione um fundo para buscar os dados do estoque.
            </h6>
            <h6
              *ngIf="allStock?.stockVariableIncome?.loanPositions?.length == 0"
            >
              Não foram encontrados dados de estoque para esta carteira.
            </h6>
            <div
              class="table-container"
              *ngIf="allStock?.stockVariableIncome?.loanPositions?.length > 0"
            >
              <div class="table-container">
                <table
                  mat-table
                  [dataSource]="allStock.stockVariableIncome.loanPositions"
                  class="col-12"
                >
                  <ng-container matColumnDef="operationCode">
                    <th mat-header-cell *matHeaderCellDef>Cód. de Operação</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.operationCode }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="assetCode">
                    <th mat-header-cell *matHeaderCellDef>Cód. Ativo</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.assetCode }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="assetName">
                    <th mat-header-cell *matHeaderCellDef>Nome do Ativo</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.assetName }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="broker">
                    <th mat-header-cell *matHeaderCellDef>Corretora</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.broker }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="loanDate">
                    <th mat-header-cell *matHeaderCellDef>
                      Data de Empréstimo>
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.loanDate | date : "dd/MM/yyyy" : "GMT" }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="dueDate">
                    <th mat-header-cell *matHeaderCellDef>
                      Data de Vencimento
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.dueDate | date : "dd/MM/yyyy" : "GMT" }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="loanAmount">
                    <th mat-header-cell *matHeaderCellDef>
                      Quantidade Empréstimo
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.loanAmount }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="loanValue">
                    <th mat-header-cell *matHeaderCellDef>
                      Valor do Empréstimo
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.loanValue }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="remuneration">
                    <th mat-header-cell *matHeaderCellDef>
                      Porcentagem Remuneração
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.remuneration }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="isDonor">
                    <th mat-header-cell *matHeaderCellDef>É Doador?</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.isDonor ? "SIM" : "NÃO" }}
                    </td>
                  </ng-container>
                  <tr
                    mat-header-row
                    *matHeaderRowDef="columnsVariableIncomeLoan; sticky: true"
                  ></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; columns: columnsVariableIncomeLoan"
                  ></tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-expansion-panel>
    <br />
  </div>

  <div
    *ngIf="
      allStock?.stockOtherAsset?.positions?.length > 0 ||
      allStock?.stockOtherAsset?.exchangePositions?.length > 0
    "
  >
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        Estoque de Outros Ativos.
        <span *ngIf="otherPositionDate != null"
          >Data da Posição:
          {{ otherPositionDate | date : "dd/MM/yyyy" : "GMT" }}</span
        >
      </mat-expansion-panel-header>
      <div class="d-block p-2 bg-dark text-white text-center">
        À vista. {{ otherPositionCount }}
      </div>
      <div class="card-body">
        <div class="row mb-2">
          <div class="col-12">
            <h6 *ngIf="allStock?.stockOtherAsset?.positions == null">
              Selecione um fundo para buscar os dados do estoque.
            </h6>
            <h6 *ngIf="allStock?.stockOtherAsset?.positions?.length == 0">
              Não foram encontrados dados de estoque para esta carteira.
            </h6>
            <div
              class="table-container"
              *ngIf="allStock?.stockOtherAsset?.positions?.length > 0"
            >
              <div class="table-container">
                <table
                  mat-table
                  [dataSource]="allStock.stockOtherAsset.positions"
                  class="col-12"
                >
                  <ng-container matColumnDef="assetCode">
                    <th mat-header-cell *matHeaderCellDef>Cód. Ativo</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.assetCode }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="assetName">
                    <th mat-header-cell *matHeaderCellDef>Nome do Ativo</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.assetName }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="assetType">
                    <th mat-header-cell *matHeaderCellDef>Tipo de Ativo</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.assetType }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="movementCode">
                    <th mat-header-cell *matHeaderCellDef>Cód. Movimentação</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.movementCode }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="date">
                    <th mat-header-cell *matHeaderCellDef>Data</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.date | date : "dd/MM/yyyy" : "GMT" }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="value">
                    <th mat-header-cell *matHeaderCellDef>Valor</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.value }}
                    </td>
                  </ng-container>

                  <tr
                    mat-header-row
                    *matHeaderRowDef="columnsOtherAsset; sticky: true"
                  ></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; columns: columnsOtherAsset"
                  ></tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-block p-2 bg-dark text-white text-center">
        Câmbio. {{ otherexchangePositionCount }}
      </div>
      <div class="card-body">
        <div class="row mb-2">
          <div class="col-12">
            <h6 *ngIf="allStock?.stockOtherAsset?.exchangePositions == null">
              Selecione um fundo para buscar os dados do estoque.
            </h6>
            <h6
              *ngIf="allStock?.stockOtherAsset?.exchangePositions?.length == 0"
            >
              Não foram encontrados dados de estoque para esta carteira.
            </h6>
            <div
              class="table-container"
              *ngIf="allStock?.stockOtherAsset?.exchangePositions?.length > 0"
            >
              <div class="table-container">
                <table
                  mat-table
                  [dataSource]="allStock.stockOtherAsset.exchangePositions"
                  class="col-12"
                >
                  <ng-container matColumnDef="assetCode">
                    <th mat-header-cell *matHeaderCellDef>Cód. Ativo</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.assetCode }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="description">
                    <th mat-header-cell *matHeaderCellDef>Descrição</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.description }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="dueDate">
                    <th mat-header-cell *matHeaderCellDef>
                      Data de Vencimento
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.dueDate }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="soldCurrency">
                    <th mat-header-cell *matHeaderCellDef>Moeda Vendida</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.soldCurrency }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="purchasedCurrency">
                    <th mat-header-cell *matHeaderCellDef>Moeda Comprada</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.purchasedCurrency }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="soldCurrencyValue">
                    <th mat-header-cell *matHeaderCellDef>
                      Valor da Moeda Vendida
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{
                        element.soldCurrencyValue
                          | currency : "R$" : "symbol" : "1.2-2"
                      }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="purchasedCurrencyValue">
                    <th mat-header-cell *matHeaderCellDef>
                      Valor da Moeda Comprada
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.purchasedCurrencyValue }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="initialParity">
                    <th mat-header-cell *matHeaderCellDef>
                      Paridade Contratação
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.initialParity }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="currentParity">
                    <th mat-header-cell *matHeaderCellDef>Pardidade Atual</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.currentParity }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="value">
                    <th mat-header-cell *matHeaderCellDef>Valor</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.value }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="modality">
                    <th mat-header-cell *matHeaderCellDef>Modalidade</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.modality }}
                    </td>
                  </ng-container>

                  <tr
                    mat-header-row
                    *matHeaderRowDef="columnsOtherAssetExchange; sticky: true"
                  ></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; columns: columnsOtherAssetExchange"
                  ></tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-expansion-panel>
    <br />
  </div>

  <div
    *ngIf="
      allStock?.stockDerivative?.futuresPositions?.length > 0 ||
      allStock?.stockDerivative?.optionsPositions?.length > 0 ||
      allStock?.stockDerivative?.swapPositions?.length > 0
    "
  >
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        Estoque de Derivativos.
        <span *ngIf="derivativePositionDate != null"
          >Data da Posição:
          {{ derivativePositionDate | date : "dd/MM/yyyy" : "GMT" }}</span
        >
      </mat-expansion-panel-header>
      <div class="d-block p-2 bg-dark text-white text-center">
        Futuros. {{ derivativeFuturesPositionCount }}
      </div>
      <div class="card-body">
        <div class="row mb-2">
          <div class="col-12">
            <h6 *ngIf="allStock?.stockDerivative?.futuresPositions == null">
              Selecione um fundo para buscar os dados do estoque.
            </h6>
            <h6
              *ngIf="allStock?.stockDerivative?.futuresPositions?.length == 0"
            >
              Não foram encontrados dados de estoque para esta carteira.
            </h6>
            <div
              class="table-container"
              *ngIf="allStock?.stockDerivative?.futuresPositions?.length > 0"
            >
              <div class="table-container">
                <table
                  mat-table
                  [dataSource]="allStock.stockDerivative.futuresPositions"
                  class="col-12"
                >
                  <ng-container matColumnDef="assetCode">
                    <th mat-header-cell *matHeaderCellDef>Cód. Ativo</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.asset }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="expiration">
                    <th mat-header-cell *matHeaderCellDef>Cód. de Expiração</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.expiration }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="dueDate">
                    <th mat-header-cell *matHeaderCellDef>
                      Data de Vencimento
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.dueDate | date : "dd/MM/yyyy" : "GMT" }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="broker">
                    <th mat-header-cell *matHeaderCellDef>Corretora</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.broker }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="amount">
                    <th mat-header-cell *matHeaderCellDef>Quantidade</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.amount }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="valuationAdjustment">
                    <th mat-header-cell *matHeaderCellDef>
                      Ajuste Valorização
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.valuationAdjustment }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="marketPrice">
                    <th mat-header-cell *matHeaderCellDef>Preço de Mercado</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.marketPrice }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="marketValue">
                    <th mat-header-cell *matHeaderCellDef>Valor de Mercado</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.marketValue }}
                    </td>
                  </ng-container>

                  <tr
                    mat-header-row
                    *matHeaderRowDef="columnsDerivativeFutures; sticky: true"
                  ></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; columns: columnsDerivativeFutures"
                  ></tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-block p-2 bg-dark text-white text-center">
        Opções. {{ derivativeOptionsPositionCount }}
      </div>
      <div class="card-body">
        <div class="row mb-2">
          <div class="col-12">
            <h6 *ngIf="allStock?.stockDerivative?.optionsPositions == null">
              Selecione um fundo para buscar os dados do estoque.
            </h6>
            <h6
              *ngIf="allStock?.stockDerivative?.optionsPositions?.length == 0"
            >
              Não foram encontrados dados de estoque para esta carteira.
            </h6>
            <div
              class="table-container"
              *ngIf="allStock?.stockDerivative?.optionsPositions?.length > 0"
            >
              <div class="table-container">
                <table
                  mat-table
                  [dataSource]="allStock.stockDerivative.optionsPositions"
                  class="col-12"
                >
                  <ng-container matColumnDef="assetCode">
                    <th mat-header-cell *matHeaderCellDef>Cód. Ativo</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.asset }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="expiration">
                    <th mat-header-cell *matHeaderCellDef>Cód. de Expiração</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.expiration }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="dueDate">
                    <th mat-header-cell *matHeaderCellDef>
                      Data de Vencimento
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.dueDate | date : "dd/MM/yyyy" : "GMT" }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="broker">
                    <th mat-header-cell *matHeaderCellDef>Corretora</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.broker }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="function">
                    <th mat-header-cell *matHeaderCellDef>Papel</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.function }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="exerciseValue">
                    <th mat-header-cell *matHeaderCellDef>
                      Valor de Exercício
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.exerciseValue }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="type">
                    <th mat-header-cell *matHeaderCellDef>Tipo</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.type }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="amount">
                    <th mat-header-cell *matHeaderCellDef>Quantidade</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.amount }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="averageValue">
                    <th mat-header-cell *matHeaderCellDef>Custo Médio</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.averageValue }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="price">
                    <th mat-header-cell *matHeaderCellDef>Cotação</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.price }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="totalCost">
                    <th mat-header-cell *matHeaderCellDef>Valor Custo Total</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.totalCost }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="marketValue">
                    <th mat-header-cell *matHeaderCellDef>Valor de Mercado</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.marketValue }}
                    </td>
                  </ng-container>

                  <tr
                    mat-header-row
                    *matHeaderRowDef="columnsDerivativeOptions; sticky: true"
                  ></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; columns: columnsDerivativeOptions"
                  ></tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-block p-2 bg-dark text-white text-center">
        SWAP Cambial. {{ derivativeSwapPositionCount }}
      </div>
      <div class="card-body">
        <div class="row mb-2">
          <div class="col-12">
            <h6 *ngIf="allStock?.stockDerivative?.swapPositions == null">
              Selecione um fundo para buscar os dados do estoque.
            </h6>
            <h6 *ngIf="allStock?.stockDerivative?.swapPositions?.length == 0">
              Não foram encontrados dados de estoque para esta carteira.
            </h6>
            <div
              class="table-container"
              *ngIf="allStock?.stockDerivative?.swapPositions?.length > 0"
            >
              <div class="table-container">
                <table
                  mat-table
                  [dataSource]="allStock.stockDerivative.swapPositions"
                  class="col-12"
                >
                  <ng-container matColumnDef="assetCode">
                    <th mat-header-cell *matHeaderCellDef>Cód. Ativo</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.asset }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="series">
                    <th mat-header-cell *matHeaderCellDef>Série</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.series }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="dueDate">
                    <th mat-header-cell *matHeaderCellDef>
                      Data de Vencimento
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.dueDate | date : "dd/MM/yyyy" : "GMT" }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="broker">
                    <th mat-header-cell *matHeaderCellDef>Corretora</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.broker }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="amount">
                    <th mat-header-cell *matHeaderCellDef>Quantidade</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.amount }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="marketValue">
                    <th mat-header-cell *matHeaderCellDef>Preço de Mercado</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.marketValue }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="couponTip">
                    <th mat-header-cell *matHeaderCellDef>Ponta Cupom</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.couponTip }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="finalValueTip">
                    <th mat-header-cell *matHeaderCellDef>Ponta Valor Final</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.finalValueTip }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="adjust">
                    <th mat-header-cell *matHeaderCellDef>Ajuste</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.adjust }}
                    </td>
                  </ng-container>

                  <tr
                    mat-header-row
                    *matHeaderRowDef="columnsDerivativeSwap; sticky: true"
                  ></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; columns: columnsDerivativeSwap"
                  ></tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-expansion-panel>
    <br />
  </div>
  <div *ngIf="allStock?.stockSwapCetip?.positions?.length > 0">
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        Estoque de Swap-CETIP.
        <span *ngIf="cetipSwapPositionDate != null"
          >Data da Posição:
          {{ cetipSwapPositionDate | date : "dd/MM/yyyy" : "GMT" }}</span
        >
      </mat-expansion-panel-header>
      <mat-expansion-panel [expanded]=""> </mat-expansion-panel>
      <div class="d-block p-2 bg-dark text-white text-center">
        Swap-CETIP. {{ cetipSwapPositionCount }}
      </div>
      <div class="card-body">
        <div class="row mb-2">
          <div class="col-12">
            <h6 *ngIf="allStock?.stockSwapCetip?.positions == null">
              Selecione um fundo para buscar os dados do estoque.
            </h6>
            <h6 *ngIf="allStock?.stockSwapCetip?.positions?.length == 0">
              Não foram encontrados dados de estoque para esta carteira.
            </h6>
            <div
              class="table-container"
              *ngIf="allStock?.stockSwapCetip?.positions?.length > 0"
            >
              <div class="table-container">
                <table
                  mat-table
                  [dataSource]="allStock.stockSwapCetip.positions"
                  class="col-12"
                >
                  <ng-container matColumnDef="operationCode">
                    <th mat-header-cell *matHeaderCellDef>Cod. Operação</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.operationCode }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="broker">
                    <th mat-header-cell *matHeaderCellDef>Corretora</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.broker }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="counterpart">
                    <th mat-header-cell *matHeaderCellDef>Contraparte</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.counterpart }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="startDate">
                    <th mat-header-cell *matHeaderCellDef>Data Inicial</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.startDate | date : "dd/MM/yyyy" : "GMT" }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="appreciationInitialDate">
                    <th mat-header-cell *matHeaderCellDef>
                      Data Inicial de Valorização
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{
                        element.appreciationInitialDate
                          | date : "dd/MM/yyyy" : "GMT"
                      }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="dueDate">
                    <th mat-header-cell *matHeaderCellDef>
                      Data de Vencimento
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.dueDate | date : "dd/MM/yyyy" : "GMT" }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="financial">
                    <th mat-header-cell *matHeaderCellDef>Financeiro</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.financial }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="passiveIndexer">
                    <th mat-header-cell *matHeaderCellDef>Indexador Passivo</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.passiveIndexer }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="passiveTaxValue">
                    <th mat-header-cell *matHeaderCellDef>
                      Valor Taxa Passivo
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.passiveTaxValue }}%
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="passiveFinancial">
                    <th mat-header-cell *matHeaderCellDef>
                      Financeiro Passivo
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.passiveFinancial }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="activeIndexer">
                    <th mat-header-cell *matHeaderCellDef>Indexador Ativo</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.activeIndexer }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="activeTaxValue">
                    <th mat-header-cell *matHeaderCellDef>Valor Taxa Ativo</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.activeTaxValue }}%
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="activeFinancial">
                    <th mat-header-cell *matHeaderCellDef>Financeiro Ativo</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.activeFinancial }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="appropriateNetFinancial">
                    <th mat-header-cell *matHeaderCellDef>
                      Financeiro Apropriado Liquido
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.appropriateNetFinancial }}
                    </td>
                  </ng-container>

                  <tr
                    mat-header-row
                    *matHeaderRowDef="columnsCetipSwap; sticky: true"
                  ></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; columns: columnsCetipSwap"
                  ></tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-expansion-panel>
    <br />
  </div>
</div>
